<template lang="pug">
.criticidade
    b {{ $t('mensagens.diagnosticoSocioambiental.criticidadeDaRestricao') }}:
    |
    | {{ restricao.nivelAlerta }}
    i.m-2.el-icon-remove-outline.custon-icon-el(
        v-if='(restricao.status && restricao.status === "ERROR")'
    )
    i.m-2.flow.flow-verified.verde.mr8.custon-icon(
        v-else-if='(restricao.nivelAlerta && restricao.nivelAlerta === "BAIXO")'
    )
    i.m-2.flow.flow-warning-sign.amarelo.mr8.custon-icon(
        v-else-if='(restricao.nivelAlerta && restricao.nivelAlerta === "MEDIO")'
    )
    i.m-2.flow.flow-warning-sign.vermelho.mr8.custon-icon(
        v-else='(restricao.nivelAlerta && restricao.nivelAlerta === "ALTO") || (!restricao.nivelAlerta)'
    )
</template>

<script>
export default {
    name: 'criticidade',
    data() {
        return {};
    },

    props: {
        restricao: {
            type: Object,
            required: true
        }
    }
};
</script>
<style lang="scss"></style>
